import { cn } from '@/lib/cn';
import { isLineType } from '../lib/lineMath';

interface TaskDotProps {
  index: number;
  /** X coordinate as percentage (0–100) */
  coordX: number;
  /** Y coordinate as percentage (0–100) */
  coordY: number;
  taskType?: string;
  opacity?: number;
  isSelected?: boolean;
  onClick?: () => void;
  /** Disable pointer events (e.g. while drawing) */
  pointerEventsNone?: boolean;
}

/**
 * Numbered circular marker positioned at a percentage-based coordinate.
 * Green by default, red for arrow/line task types.
 */
export function TaskDot({
  index,
  coordX,
  coordY,
  taskType,
  opacity = 1,
  isSelected = false,
  onClick,
  pointerEventsNone = false,
}: TaskDotProps) {
  const isArrowType = taskType ? isLineType(taskType) : false;

  return (
    <div
      className={cn('absolute z-5 -translate-x-1/2 -translate-y-1/2 cursor-pointer', pointerEventsNone && 'pointer-events-none')}
      style={{ left: `${coordX}%`, top: `${coordY}%`, opacity }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div
        className={cn(
          'flex size-10 items-center justify-center rounded-full transition-all max-sm:size-[30px]',
          isArrowType
            ? 'bg-destructive hover:bg-destructive-hover'
            : 'bg-primary hover:bg-primary-hover',
          isSelected && 'ring-2 ring-white scale-110',
        )}
        onClick={onClick}
      >
        <span className="text-2xl font-black text-white max-sm:text-xl">{index}</span>
      </div>
    </div>
  );
}
